module.exports = __webpack_public_path__ + "static/media/gold-mine.3f61483d.jpg";